import { BillingPeriod } from "@redotech/redo-billing-common/service-invoice";
import { zUsdDollars } from "@redotech/redo-model/currency";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

const checkoutOptimizationUsageServiceInvoiceStatus = z.object({
  type: z.literal("usage"),
  period: createEnum(BillingPeriod),
  billingDueDate: z.date(),
  estimatedInvoiceAmount: z.number(),
  billableOrdersThisPeriod: z.number(),
  pricePerOrderInCents: z.number(),
  renewOnPeriodEnd: z.boolean(),
});
export type CheckoutOptimizationUsageServiceInvoiceStatus = z.infer<
  typeof checkoutOptimizationUsageServiceInvoiceStatus
>;

const checkoutOptimizationSubscriptionServiceInvoiceStatus = z.object({
  type: z.literal("subscription"),
  period: createEnum(BillingPeriod),
  billingDueDate: z.date(),
  estimatedInvoiceAmount: zUsdDollars,
});
export type CheckoutOptimizationSubscriptionServiceInvoiceStatus = z.infer<
  typeof checkoutOptimizationSubscriptionServiceInvoiceStatus
>;

export const getCurrentCheckoutOptimizationInvoice = {
  name: "getCurrentCheckoutOptimizationInvoice" as const,
  input: z.null(),
  output: z
    .union([
      checkoutOptimizationUsageServiceInvoiceStatus,
      checkoutOptimizationSubscriptionServiceInvoiceStatus,
    ])
    .nullable(),
};
